import BaseSliderView from './BaseSliderView';
import $ from 'jquery';

export default BaseSliderView.extend({

    events: {
        'click .pdp-show-more-accessories': 'onShowMoreClick',
        'click .pdp-show-less-accessories': 'onShowLessClick'
    },

    onShowMoreClick: function () {
        this.$('.js-below-fold').removeClass('is-hidden');
        this.$('.pdp-show-less-accessories').removeClass('is-hidden');
        this.$('.pdp-show-more-accessories').addClass('is-hidden');
    },

    onShowLessClick: function () {
        this.$('.js-below-fold').addClass('is-hidden');
        this.$('.pdp-show-less-accessories').addClass('is-hidden');
        this.$('.pdp-show-more-accessories').removeClass('is-hidden');

        $('body, html').animate({
            scrollTop: this.$el.offset().top
        }, 10);
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/sliders/AccessoriesSliderView.js
 **/